import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SelectConflictCalendar as SelectConflictCalendarMutation,
    SelectConflictCalendarVariables as SelectConflictCalendarVariables,
} from 'nutshell-graphql-types';

import SELECT_CONFLICT_CALENDAR from '../mutations/select-conflict-calendar.graphql';
import GET_CONFLICT_CALENDARS from '../queries/get-calendars.graphql';

export const useSelectConflictCalendar = (): {
    selectConflictCalendar: (id: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [selectConflictCalendar, {loading, error}] = useMutation<
        SelectConflictCalendarMutation,
        SelectConflictCalendarVariables
    >(SELECT_CONFLICT_CALENDAR);

    return {
        selectConflictCalendar: (id: string) =>
            selectConflictCalendar({
                variables: {calendar: {id, syncType: 'CONFLICT'}},
                update: (proxy, mutationResults) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_CONFLICT_CALENDARS,
                    });

                    const newCalendars =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.selectCalendarSyncCalendar &&
                        mutationResults.data.selectCalendarSyncCalendar.calendars;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_CONFLICT_CALENDARS,
                            data: {
                                ...cacheResult,
                                calendars: newCalendars,
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
